import { render, staticRenderFns } from "./type55.vue?vue&type=template&id=d845b92a&scoped=true"
import script from "./type55.vue?vue&type=script&lang=js"
export * from "./type55.vue?vue&type=script&lang=js"
import style0 from "./type55.vue?vue&type=style&index=0&id=d845b92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d845b92a",
  null
  
)

export default component.exports